import { Component, OnInit } from '@angular/core'
import { collection, Firestore, getDocs } from '@angular/fire/firestore'
import { Dog } from 'src/domain/dog'
import { ListDog } from '../components/dog-list/dog-list.component'
import { mapFirebaseDog } from '../service/mapper/dogMapper'

@Component({
    selector: 'app-active-dogs',
    styleUrls: ['./active-dogs.component.scss'],
    templateUrl: './active-dogs.component.html',
    standalone: false
})
export class ActiveDogsComponent implements OnInit {
  constructor(private store: Firestore) {}

  fullDogList: ListDog[] = []

  ngOnInit(): void {
    getDocs(collection(this.store, 'dogs')).then((snapshot) => {
      this.fullDogList = snapshot.docs
        .map(
          (doc) =>
            ({
              ...mapFirebaseDog(doc.data() as Dog),
              docId: doc.id,
            } as ListDog)
        )
        .filter((d) => !d.deletedAt && !d.retiredAt)
    })
  }
}
